
<div *ngIf="successMessage" class="alert alert-success mt-2">
  {{ successMessage }}
</div>


<div class="register-container shadow p-4 rounded bg-white">
  <h2 class="text-center mb-4 text-primary">فرم ثبت‌ نام</h2>

  <form (ngSubmit)="onSubmit()" #registerForm="ngForm">
    <div class="form-group mb-3">
      <label for="username" class="form-label">نام کاربری</label>
      <input
        type="text"
        id="username"
        class="form-control"
        required
        [(ngModel)]="registerData.username"
        name="username"
        placeholder="مثلاً jozef"
      />
    </div>

    <div class="form-group mb-3">
      <label for="password" class="form-label">رمز عبور</label>
      <input
        type="password"
        id="password"
        class="form-control"
        required
        [(ngModel)]="registerData.password"
        name="password"
        placeholder="رمزخود را وارد کنید"
      />
    </div>

    <div class="form-group mb-3">
      <label for="email" class="form-label">ایمیل</label>
      <input
        type="email"
        id="email"
        class="form-control"
        required
        [(ngModel)]="registerData.email"
        name="email"
        placeholder="example@email.com"
      />
    </div>

    <div class="form-group mb-4">
      <label for="phoneNumber" class="form-label">تلفن</label>
      <input
        type="text"
        id="phoneNumber"
        class="form-control"
        required
        [(ngModel)]="registerData.phoneNumber"
        name="phoneNumber"
        placeholder="مثلاً 09123456789"
      />
    </div>

    <button
      type="submit"
      class="btn btn-success w-100"
      [disabled]="!registerForm.valid"
    >
      ثبت‌نام
    </button>
  </form>
</div>
